(() => {
  const messages = JSON.parse(document.getElementById('AvelioMessages')?.textContent || '{}');
  const root = messages.root || '/';
  const cart = document.getElementById('AvelioCart');
  let returnFocus;
  const money = (value, currency = messages.currency || 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency}).format(value / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  async function request(path, data) {
    const response = await fetch(root + path, data ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(data)} : {headers:{'Accept':'application/json'},cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || messages.cartError);
    return result;
  }
  function renderCart(data) {
    const body = cart.querySelector('[data-cart-body]');
    const footer = cart.querySelector('[data-cart-footer]');
    footer.hidden = !data.item_count;
    if (!data.item_count) body.innerHTML = `<div class="avelio-cart-empty"><p>${escape(messages.empty)}</p><a href="${root}products/avelio-heat-massage-belt">${escape(messages.continue)}</a></div>`;
    else body.innerHTML = data.items.map(item => `<article class="avelio-cart-item"><a href="${escape(item.url)}">${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.product_title)}" width="82" height="82">` : ''}</a><div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escape(item.variant_title)}</span>` : ''}<div class="avelio-cart-item-price"><strong>${item.final_line_price === 0 ? escape(messages.free) : money(item.final_line_price,data.currency)}</strong>${item.original_line_price > item.final_line_price ? `<del>${money(item.original_line_price,data.currency)}</del>` : ''}</div>${(item.line_level_discount_allocations || []).map(discount => `<div class="avelio-cart-discount">${escape(discount.discount_application.title)}</div>`).join('')}<div class="avelio-cart-line-controls"><div class="avelio-cart-quantity" aria-label="${escape(messages.quantity)}"><button type="button" data-cart-key="${escape(item.key)}" data-cart-quantity="${item.quantity-1}" aria-label="${escape(messages.decrease)}">−</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-quantity="${item.quantity+1}" aria-label="${escape(messages.increase)}">+</button></div><button type="button" class="avelio-cart-remove" data-cart-key="${escape(item.key)}" data-cart-quantity="0">${escape(messages.remove)}</button></div></div></article>`).join('');
    cart.querySelector('[data-cart-total]').textContent = money(data.total_price,data.currency);
    const savings = cart.querySelector('[data-cart-savings]');
    savings.hidden = !data.total_discount;
    savings.innerHTML = `<span>${escape(messages.savings)}</span><strong>${money(data.total_discount,data.currency)}</strong>`;
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(node => node.textContent = data.item_count);
    document.querySelectorAll('[data-avelio-cart-open]').forEach(node => {node.dataset.count=data.item_count;let badge=node.querySelector('.avelio-cart-count');if(!badge){badge=document.createElement('span');badge.className='avelio-cart-count';node.append(badge);}badge.textContent=data.item_count;badge.hidden=!data.item_count;});
  }
  async function refreshCart(open = false) {
    const data = await request('cart.js');
    renderCart(data);
    if (open && !cart.open) {returnFocus = document.activeElement;cart.showModal();}
    return data;
  }
  function closeCart() {cart.close();returnFocus?.focus();}
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-avelio-cart-open]');
    if (opener) {event.preventDefault();try {await refreshCart(true);} catch {location.href = root + 'cart';}return;}
    if (event.target.closest('[data-cart-close]')) closeCart();
    const quantity = event.target.closest('[data-cart-key]');
    if (quantity) {
      const controls = [...cart.querySelectorAll('[data-cart-key]')];controls.forEach(button => button.disabled=true);
      try {await request('cart/change.js',{id:quantity.dataset.cartKey,quantity:Number(quantity.dataset.cartQuantity)});await refreshCart();}
      catch(error) {cart.querySelector('[data-cart-body]').insertAdjacentHTML('afterbegin',`<p class="avelio-error">${escape(error.message)}</p>`);}
      finally {controls.forEach(button => button.disabled=false);}
    }
    const thumbnail = event.target.closest('.shop-thumbnail');
    if (thumbnail) {
      const container = thumbnail.closest('.shop-product-section');
      const mediaId = thumbnail.dataset.mediaId;
      container.querySelectorAll('.shop-thumbnail').forEach(node => node.classList.toggle('active',node.dataset.mediaId === mediaId));
      container.querySelectorAll('.shop-image-container > *').forEach(node => {const active = node.dataset.mediaId === mediaId || node.id === thumbnail.dataset.target;node.classList.toggle('active',active);node.querySelectorAll('.shop-main-image').forEach(image => image.classList.toggle('active',active));if(!active) node.querySelectorAll('video').forEach(video => video.pause());});
    }
    const question = event.target.closest('.faq-question');
    if (question) {const item=question.closest('.faq-item');const active=!item.classList.contains('active');item.classList.toggle('active',active);question.setAttribute('aria-expanded',String(active));}
    const tab = event.target.closest('button[data-tab]');
    if (tab) {const section=tab.closest('.shopify-section');section.querySelectorAll('button[data-tab]').forEach(button=>{const active=button===tab;button.classList.toggle('active',active);button.setAttribute('aria-selected',String(active));const panel=document.getElementById(button.dataset.tab);if(panel){panel.classList.toggle('active',active);panel.hidden=!active;}});}
  });
  document.addEventListener('keydown',event=>{if((event.key==='Enter'||event.key===' ')&&event.target.matches('.shop-thumbnail,.faq-question')){event.preventDefault();event.target.click();}});
  cart?.addEventListener('click',event=>{if(event.target===cart){const bounds=cart.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right)closeCart();}});
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-avelio-product-form]');if(!form)return;
    event.preventDefault();const button=form.querySelector('[name="add"]');if(button.disabled)return;button.disabled=true;form.querySelector('.avelio-error')?.remove();
    try {const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const data=await response.json();if(!response.ok)throw new Error(data.description||messages.addError);await refreshCart(true);document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:await request('cart.js')}}));}
    catch(error){form.insertAdjacentHTML('beforeend',`<p class="avelio-error" role="alert">${escape(error.message)}</p>`);}
    finally{button.disabled=false;}
  });
  document.querySelectorAll('.product-card-clickable[data-product-url]').forEach(card=>card.addEventListener('click',()=>location.href=root+'products/avelio-heat-massage-belt'));
  window.AvelioCart = {open:()=>refreshCart(true),refresh:()=>refreshCart(),close:closeCart};
  if(document.body.dataset.openCart==='true')refreshCart(true);
})();

(() => {
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const carousels = new WeakMap();

  document.addEventListener('click', event => {
    const button = event.target.closest('.reviews-transformation-section .nav-button');
    if (!button) return;
    const track = button.closest('.reviews-transformation-section').querySelector('.reviews-container');
    const card = track?.querySelector('.review-card');
    if (!card) return;
    event.preventDefault();
    const step = card.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 20);
    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    const previous = button.classList.contains('prev');
    const left = previous
      ? (track.scrollLeft <= 5 ? max : Math.max(0, track.scrollLeft - step))
      : (track.scrollLeft >= max - 5 ? 0 : Math.min(max, track.scrollLeft + step));
    track.scrollTo({left, behavior: reducedMotion() ? 'instant' : 'smooth'});
  });

  class ReviewCarousel {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('.testimonials-carousel');
      this.track = section.querySelector('.testimonials-track');
      this.originals = [...this.track.querySelectorAll('.testimonial-card:not(.testimonial-clone)')];
      this.dots = [...section.querySelectorAll('.dot[data-slide]')];
      this.count = this.originals.length;
      this.events = new AbortController();
      this.rebuild(0);
      const options = {signal: this.events.signal};
      section.addEventListener('click', event => {
        const arrow = event.target.closest('.nav-button');
        const dot = event.target.closest('.dot[data-slide]');
        if (arrow) {
          event.preventDefault();
          this.move(arrow.classList.contains('prev') ? -1 : 1);
        } else if (dot) {
          event.preventDefault();
          this.goTo(Number(dot.dataset.slide));
        }
      }, options);
      this.track.addEventListener('touchstart', event => {
        if (this.busy || event.touches.length !== 1) return;
        this.touch = {x: event.touches[0].clientX, y: event.touches[0].clientY};
      }, {...options, passive: true});
      this.track.addEventListener('touchmove', event => {
        if (!this.touch || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - this.touch.x;
        const dy = event.touches[0].clientY - this.touch.y;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 20 && event.cancelable) event.preventDefault();
      }, {...options, passive: false});
      this.track.addEventListener('touchend', event => {
        if (!this.touch) return;
        const end = event.changedTouches[0];
        const dx = end.clientX - this.touch.x;
        const dy = end.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) this.move(dx > 0 ? -1 : 1);
      }, {...options, passive: true});
      this.track.addEventListener('touchcancel', () => {this.touch = null;}, options);
      this.observer = new ResizeObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.mobile !== matchMedia('(max-width: 749px)').matches) this.rebuild(this.realIndex());
          else this.position(false);
        });
      });
      this.observer.observe(this.viewport);
      document.fonts.ready.then(() => {if (this.section.isConnected) this.position(false);});
    }

    realIndex() {
      return ((this.slide - this.buffer) % this.count + this.count) % this.count;
    }

    clone(card) {
      const copy = card.cloneNode(true);
      copy.classList.add('testimonial-clone');
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      return copy;
    }

    rebuild(index) {
      clearTimeout(this.timer);
      this.busy = false;
      this.track.querySelectorAll('.testimonial-clone').forEach(card => card.remove());
      this.mobile = matchMedia('(max-width: 749px)').matches;
      this.buffer = this.count > 1 ? (this.mobile ? 1 : this.count) : 0;
      if (this.count > 1) {
        const before = this.mobile ? [this.originals.at(-1)] : [...this.originals].reverse();
        const after = this.mobile ? [this.originals[0]] : this.originals;
        this.track.prepend(...before.map(card => this.clone(card)));
        this.track.append(...after.map(card => this.clone(card)));
      }
      this.cards = [...this.track.querySelectorAll('.testimonial-card')];
      this.slide = this.buffer + index;
      this.position(false);
    }

    position(animate) {
      const card = this.cards[this.slide];
      if (!card || !this.viewport.offsetWidth) return;
      let offset;
      if (this.mobile) {
        const viewportRect = this.viewport.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const transform = getComputedStyle(this.track).transform;
        const current = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m41;
        offset = current + viewportRect.left + viewportRect.width / 2 - cardRect.left - cardRect.width / 2;
      } else {
        const width = this.cards[0].offsetWidth;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        offset = this.viewport.offsetWidth / 2 - width / 2 - (width + gap) * (this.slide + 2);
      }
      this.track.style.transition = animate && !reducedMotion() ? 'transform 0.3s ease' : 'none';
      this.track.style.transform = `translateX(${offset}px)`;
      const active = this.realIndex();
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === active);
        if (index === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    animateTo(slide) {
      if (this.busy || this.count < 2) return;
      this.busy = true;
      this.slide = slide;
      this.position(true);
      this.timer = setTimeout(() => {
        this.slide = this.buffer + this.realIndex();
        this.position(false);
        this.busy = false;
      }, reducedMotion() ? 0 : 350);
    }

    move(direction) {this.animateTo(this.slide + direction);}
    goTo(index) {if (Number.isInteger(index) && index >= 0 && index < this.count) this.animateTo(this.buffer + index);}
    destroy() {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.events.abort();
      this.observer.disconnect();
    }
  }

  function initialize(root) {
    root.querySelectorAll('.testimonials-section').forEach(section => {
      if (!carousels.has(section) && section.querySelector('.testimonial-card')) carousels.set(section, new ReviewCarousel(section));
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.testimonials-section').forEach(section => {
    carousels.get(section)?.destroy();
    carousels.delete(section);
  }));
})();
